module.exports = __webpack_public_path__ + "img/mantou.ee3cb94d.png";